// extracted by mini-css-extract-plugin
export var ourUser = "index-module--ourUser--L9Y22";